import { isAndroidApp, isHzwApp, isIosApp, isRkhy } from './cookie'

import { getCityId } from './city'
import { Location } from './location'
import { ajax } from './interceptor'
import { split } from 'lodash'

export async function setTitle(titlename = '孕产·亲子') {
  try {
    document.title = titlename
    setShareInfo({ title: titlename })
    if (window.kwapp && isHzwApp()) {
      if (window.kwapp.setTitle) {
        window.kwapp.setTitle(titlename)
      } else if (window.kwapp.onReady) {
        window.kwapp.onReady(() => {
          window.kwapp.setTitle(titlename)
        })
      }
    }
  } catch (e) {
    console.log(e)
  }
}

interface shareInfoConfig {
  title?: string // 标题
  desc?: string // 秒杀
  imgUrl?: string // 图片
  link?: string // 链接
  path?: string // 小程序页面路径
  mpType?: number // 小程序版本0正式版;1开发版;2体验版;
}
export function setShareInfo(config: shareInfoConfig = {}) {
  if (!isHzwApp() && !isRkhy()) {
    return
  }
  const shareInfo = {
    title: '孕产·亲子',
    desc: '孩子王孕产亲子平台，为您优选品质服务',
    imgUrl: '',
    link: location.href,
    ...config
  }
  const shareInfoConfig = {
    ...shareInfo,
    webpageUrl: shareInfo.link,
    mpTitle: shareInfo.title,
    mpDescription: shareInfo.desc,
    thumbUrl: shareInfo.imgUrl,
    path: shareInfo.path || `pages/mall-index/index?refererH5=${encodeURIComponent(shareInfo.link)}`,
    mpType: 0 || config.mpType
  }
  try {
    console.log(shareInfoConfig)

    window.getAppShareInfo = () => shareInfoConfig
  } catch (e) {
    console.log(e)
  }
}

/**
 * app和小程序分享设置
 * https://note.youdao.com/ynoteshare1/index.html?id=5642808b53f6e532cc622ca932662818&type=note#/
 */

export function setNativeShareInfo() {
  // todo
}

export function allowRefreshOrShare(canRefresh = true, canShare = true): void {
  try {
    if (window.kwapp) {
      if (window.kwapp.allowRefreshOrShare) {
        window.kwapp.allowRefreshOrShare(canRefresh, canShare)
      } else if (window.kwapp.onReady) {
        window.kwapp.onReady(() => {
          window.kwapp.allowRefreshOrShare(canRefresh, canShare)
        })
      }
    }
  } catch (e) {
    console.log(e)
  }
}

export function setNativeInfo(options: any = {}, isiOS: boolean) {
  options = options || {}
  options.targetClass = options.targetClass || ''
  options.methodType = options.methodType || '0'
  options.methodName = options.methodName || ''
  options.parm = options.parm || []
  const str = JSON.stringify(options)
  try {
    if (isiOS) {
      window.app && window.app.jsNavtiveHandle && window.app.jsNavtiveHandle(str)
    } else {
      window.localjs && window.localjs.invokeNativeMethod && window.localjs.invokeNativeMethod(str)
    }
  } catch (error) {
    console.log(error)
  }
}

export function invokeCopy({ value = '', showTips = true, successMsg = '复制成功', failMsg = '复制失败' }) {
  let options = null
  if (navigator.userAgent) {
    const u = navigator.userAgent
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if (isiOS) {
      options = showTips
        ? {
            targetClass: 'HZWPasteboardManager',
            methodType: '0',
            methodName: 'copyText_smsg_fmsg_',
            parm: [
              {
                parmClass: 's',
                parmValue: value
              },
              {
                parmClass: 's',
                parmValue: successMsg
              },
              {
                parmClass: 's',
                parmValue: failMsg
              }
            ]
          }
        : {
            targetClass: 'HZWPasteboardManager',
            methodType: '0',
            methodName: 'copyText_',
            parm: [
              {
                parmClass: 's',
                parmValue: value
              }
            ]
          }
    } else {
      options = {
        targetClass: 'com.kidswant.component.h5.HZWJsHandler',
        methodType: '0',
        methodName: 'controlCopyText',
        methodArgsTypes: 't,b',
        parm: [
          {
            parmClass: 's',
            parmKey: 'content',
            parmValue: value
          },
          {
            parmClass: 's',
            parmKey: 'success',
            parmValue: successMsg
          },
          {
            parmClass: 's',
            parmKey: 'fail',
            parmValue: failMsg
          }
        ]
      }
    }
    setNativeInfo(options, isiOS)
  }
}

/* 显示首页按钮与分享按钮, 会覆盖默认的分享按钮 */
export function showIndexAndShare(showIndex = true, showSahre = true) {
  const parmValue: any[] = []
  if (showIndex) {
    // 首页图标的base64
    const indexIconBase64 =
      'data:image/png;base64,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'
    parmValue.unshift({
      icon: indexIconBase64, // 图标（使用设计稿中44x44的那张）
      title: '', // 文案
      titleColor: '', // 6位数颜色
      link: 'https://life.cekid.com/h5/home', // 跳转页面链接（优先级其次）
      method: '', // 点击回调（优先级最低）
      methodAlways: '' //点击回调（优先级最高）
    })
  }
  if (showSahre) {
    // 分享图标的base64
    const shareIconBase64 =
      'data:image/png;base64,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'
    parmValue.unshift({
      icon: shareIconBase64,
      methodAlways: 'window.kwapp.invokeShareBoard()' // 拉起分享面板
    })
  }
  if (parmValue.length > 0) {
    try {
      if (window.kwapp) {
        if (window.kwapp.configTopButtons) {
          window.kwapp.configTopButtons(parmValue)
        } else if (window.kwapp.onReady) {
          window.kwapp.onReady(() => {
            window.kwapp.configTopButtons(parmValue)
          })
        }
      }
    } catch (e) {
      console.log(e)
    }
  }
}


export function goBackNative() {
  let options = null
  if (isIosApp()) {
    options = {
      targetClass: 'self',
      methodName: 'goBack',
      methodType: '0',
      parm: []
    }
    const str = JSON.stringify(options)
    window.app && window.app.jsNavtiveHandle && window.app.jsNavtiveHandle(str)
  } else if (isAndroidApp()) {
    window.localjs && window.localjs.goBackDefault()
  }
}